























































































import { Component, Prop, Vue } from "@/shared/vuepack";
import {
  ExpenseReimbursementStatus,
  FetchState,
  HsabExpenseFormMode,
  HsabExpenseReimbursementRepaymentResponse,
  HsabExpenseReimbursementResponse,
  LinkedBankAccountUse,
  LinkedBankAccountUseStatus,
} from "@/shared/types";
import { LinkedAccountsSettings } from "@/employee/route-names";
import { isNullEmptyOrUndefined } from "@/shared/stringHelper";
import { formatCurrency } from "@/shared/currency.js";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import { useThemeStore } from "@/shared/store/theme";
import { useBankAccountStore } from "@/employee/store/bankAccount";
import { useHsabExpenseFormStore } from "@/employee/store/hsabExpenseForm";
import { useHsabExpenseStore } from "@/employee/store/hsabExpense";
import _ from "lodash";

@Component({
  methods: {isNullEmptyOrUndefined},
  components: {
    GenericLoadingSpinner,
  }
})
export default class HsabRepayClaimExpanded extends Vue {
  formatCurrency = formatCurrency;
  themeStore = useThemeStore();
  bankAccountStore = useBankAccountStore();
  hsabExpenseStore = useHsabExpenseStore();
  hsabExpenseFormStore = useHsabExpenseFormStore();
  expenseSaving = false;

  mounted () {
    this.bankAccountStore.getBankAccountStatus();
    this.bankAccountStore.loadLinkedBankAccounts();
  }
  @Prop()
  reimbursement: HsabExpenseReimbursementResponse;

  get loading () {
    return this.bankAccountStore.linkedAccountIsLoading;
  }

  get hasOverflowReimbursements () {
    return this.reimbursement
        && this.reimbursement.overflowReimbursements
        && this.reimbursement.overflowReimbursements.length > 0;
  }

  get method () {
    if (this.hasLinkedAccount) {
      return "Direct Deposit";
    }

    return "Check";
  }
  get hasLinkedAccount (): boolean {
    return this.bankAccountStore.defaultReimbursementAccount !== undefined
        && this.bankAccountStore.defaultReimbursementAccount !== null
        && this.bankAccountStore.defaultReimbursementAccount.use !== undefined
        && this.bankAccountStore.defaultReimbursementAccount.use !== null
        && this.bankAccountStore.defaultReimbursementAccount.use.accountUse === LinkedBankAccountUse.DirectDeposit
        && this.bankAccountStore.defaultReimbursementAccount.use.status === LinkedBankAccountUseStatus.Active;
  }

  get repaymentsDue (): HsabExpenseReimbursementRepaymentResponse[] {
    return _.filter(this.reimbursement.repayments, x => x.outstandingAmount > 0 &&
        (x.status === ExpenseReimbursementStatus.None || x.status === ExpenseReimbursementStatus.Pending));
  }

  get repaymentAmountDue (): number {
    return _.sum(this.repaymentsDue.map(x => x.outstandingAmount));
  }

  get submitButtonTitle () {
    if (!this.hasLinkedAccount) {
      return "Link an active bank account in order to repay claim.";
    }
    return this.hsabExpenseFormStore.agreedToTerms ? "" : "Please accept the terms and conditions in order to proceed";
  }

  onLinkAccountClick () {
    this.$emit("back");
    this.hsabExpenseFormStore.updateModalMode(HsabExpenseFormMode.none);
    this.$router.push({
            name: LinkedAccountsSettings
          });
  }

  async onConfirmSubmitClicked () {
    this.expenseSaving = true;

    await this.hsabExpenseStore.repayAllRepayments(this.reimbursement.hsabExpenseReimbursementId);
    await this.hsabExpenseFormStore.loadExpenseForViewOrEdit(this.reimbursement.hsabExpenseId);

    this.$emit("confirmSubmit");
    this.expenseSaving = false;
  }
  onBackClicked () {
    this.$emit("back");
  }
}
